import { CE_SCREEN_CLOSE } from "@js/actions/studio/screens.js";

export const CE_SCREEN_EDITOR_OPEN = "CE_SCREEN_EDITOR_OPEN";
export const ceScreenEditorOpen = (clientContentID, format) => {
  return {
    type: CE_SCREEN_EDITOR_OPEN,
    client_content_id: clientContentID,
    format: format,
  };
};

export const CE_SCREEN_EDITOR_CANCEL = "CE_SCREEN_EDITOR_CANCEL";
export const ceScreenEditorCancel = (contentChanged) => {
  if (contentChanged) {
    return {
      type: CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL,
    };
  } else {
    return {
      type: CE_SCREEN_CLOSE,
    };
  }
};

export const CE_SCREEN_EDITOR_MARK_AS_DIRTY = "CE_SCREEN_EDITOR_MARK_AS_DIRTY";
export const ceScreenEditorMarkAsDirty = () => ({
  type: CE_SCREEN_EDITOR_MARK_AS_DIRTY,
});

export const CE_SCREEN_EDITOR_MARK_AS_CLEAN = "CE_SCREEN_EDITOR_MARK_AS_CLEAN";
export const ceScreenEditorMarkAsClean = () => ({
  type: CE_SCREEN_EDITOR_MARK_AS_CLEAN,
});

export const CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL =
  "CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL";
export const ceScreenEditorWarnBeforeCancel = () => ({
  type: CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL,
});

export const CE_SCREEN_EDITOR_ABORT_CANCELLATION =
  "CE_SCREEN_EDITOR_ABORT_CANCELLATION";
export const ceScreenEditorAbortCancellation = () => ({
  type: CE_SCREEN_EDITOR_ABORT_CANCELLATION,
});

export const CE_SCREEN_EDITOR_SAVE = "CE_SCREEN_EDITOR_SAVE";
export const ceScreenEditorSave = (beeJSON, html, text) => ({
  type: CE_SCREEN_EDITOR_SAVE,
  bee_json: beeJSON,
  html: html,
  text: text,
});
